<template>
	<div id="mapCenter" class="mapboxgl-ctrl mapboxgl-ctrl-group bg-blue-dk">
		<div v-if="loading" class="mapboxgl-ctrl-icon text-light px-2 loading-ctrl">
			<div class="loading-dots justify-content-center align-self-center">
				<div class="dot"></div>
				<div class="dot"></div>
				<div class="dot"></div>
			</div>
		</div>
		<button v-else v-on:click="center" class="mapboxgl-ctrl-icon" title="center map on current location">
			<i class="material-icons">my_location</i>
		</button>
	</div>
</template>

<script>
export default {
	name:'map-center',
	computed: {
	},
	data:function(){
		return {
			loading:false
		}
	},
	methods:{
		center: function(){
			if (navigator.geolocation){
				this.loading = true;
				// check if geolocation is supported/enabled on current browser
				navigator.geolocation.getCurrentPosition((position)=>{
					const center = [
						position.coords.longitude,
						position.coords.latitude
					];
					this.loading = false;

					this.$store.dispatch('MAP_FLY_TO', {center:center,position,zoom:18});
				},(error)=>{
					this.loading = false;
					this.$store.dispatch('ERROR_MESSAGE_SET', {message:'Error retrieving location'});
				});
			} else {
				this.$store.dispatch('ERROR_MESSAGE_SET', {message:'Geolocation not enabled in this browser'});
			}
		}
	}
}
</script>
<style>
#mapCenter button i{color:#FFF;}
.loading-ctrl{height:34px;}
.loading-ctrl .loading-dots{padding-top:2px;}
</style>


// WEBPACK FOOTER //
// src/components/map/map-center.vue